module.exports = __webpack_public_path__ + "static/media/udemy-removebg-preview.df6b1f90.png";